import React from "react";
import PropTypes from "prop-types";
import { Descriptions, Tag } from "antd";

const DescriptionItem = Descriptions.Item;

class GSTINDataRenderer extends React.Component {
    render() {
        if (this.props.data) {
            return (
                <Descriptions title="GSTIN Info" bordered>
                    <DescriptionItem label={"Trade Name"}>
                        {this.props.data && this.props.data.tradeNam}
                    </DescriptionItem>
                    <DescriptionItem label={"Constitution"}>
                        <Tag color={"#87d068"}>{this.props.data && this.props.data.ctb}</Tag>
                    </DescriptionItem>
                    <DescriptionItem label={"Registration Date"}>
                        {this.props.data && this.props.data.rgdt}
                    </DescriptionItem>
                    <DescriptionItem label={"Address"} span={3}>
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.bnm},
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.bnm ? <br /> : null}
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.bno},&nbsp;
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.flno},&nbsp;
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.flno ? <br /> : null}
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.loc},&nbsp;
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.st},&nbsp;
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.pncd}
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.pncd ? <br /> : null}
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.stcd}
                        {this.props.data && this.props.data.pradr && this.props.data.pradr.addr && this.props.data.pradr.addr.stcd ? <br /> : null}
                    </DescriptionItem>
                </Descriptions>
            );
        }
        return null;
    }
}

GSTINDataRenderer.propTypes = {
    data: PropTypes.object
};

export default GSTINDataRenderer;
